export default __webpack_public_path__ + "static/media/Newkirk_Precinct_TE.8ad67730.jpg";